import { h, defineComponent } from 'vue';
import { Button } from '@/ui/components/Button';
import { starsIcon } from '@/ui/components/icon/icons';
import { SubscribeButton } from '@/ui/components/upgrade/SubscribeButton';

interface UpgradeButtonProps {
  classes?: string;
  text?: string;
  isLoading: boolean;
}

export const UpgradeButton = defineComponent<UpgradeButtonProps>({
  name: 'UpgradeButton',
  props: ['isLoading', 'classes', 'text'],
  setup(props, ctx) {
    return function render() {
      return h(Button, {
        props: {
          btnClass: `button button-upgrade ${props.classes || ''}`,
          loading: props.isLoading,
        },
        on: {
          click: () => ctx.emit('click'),
        },
      }, [
        starsIcon(),
        props.text,
      ]);
    };
  },
});

export const upgradeButton = (
  {
    classes = '',
    text = '',
    isLoading = false,
  }: UpgradeButtonProps,
) => {
  return h(SubscribeButton, { props: { classes, text, isLoading } });
};
